import React from 'react';
import jwt_decode from 'jwt-decode';
import "devextreme/data/odata/store";
import { createStore } from "devextreme-aspnet-data-nojquery";
import plusimg from "../../images/common/plus.png"
import exportimg from "../../images/common/xlsx.png"
import editimg from "../../images/common/pencil.png"
import onimg from "../../images/admin/on-button.png"
import offimg from "../../images/admin/off-button.png"
import history from "../history";
import {Form,Row,Modal,Button as ButtonBootstrap} from "react-bootstrap";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import { ToastContainer, toast } from 'react-toastify';    
import 'react-toastify/dist/ReactToastify.css'; 
import { exportToExcel } from '../../utils/exportMethods'; 
import CustomReactSelect from './pages/customComponents/CustomReactSelect';
import { config } from '../../constants';
import '../../css/Buttons.css';
import {deleteKey} from '../../utils/exportMethods';
import ConfirmDialog from './pages/customComponents/ConfirmDialog';
import CircleSign from '../ui/CircleSign';
import ConfirmationModal from '../ui/ConfirmationModal';
import Maximize from '../ui/Maximize';
import Minimize from '../ui/Minimize';
import CustomDataGrid from './pages/customComponents/CustomDataGrid';
import apiClient from '../../utils/apiClient';
import { handleErrorResponse } from '../../utils/apiClient';

const url = config.url.URL; //"http://localhost:52344";
const buyingAgencyUrl = `${url}/BuyingAgencyMicroservice`;
const buyingAgencyNetworksUrl = `${url}/AgencyNetworkMicroservice/Dropdowns`;
const countriesLoadUrl= `${url}/GeoElementMicroservice/countriesadmindropdown`;
const countriesFromBuyingAgencyUrl = `${buyingAgencyUrl}/countries/`

const dataSource = createStore({
  key: "buyingAgencyId",
  loadUrl: `${url}/BuyingAgencyMicroservice`,
  insertUrl: `${url}/InsertOrder`,
  updateUrl: `${url}/UpdateOrder`,
  deleteUrl: `${url}/BuyingAgencyMicroservice`,
  onBeforeSend: (method, ajaxOptions) => {
    ajaxOptions.headers = {
      'accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem('token')
    }
  },
  onAjaxError: (e) => {
    const { xhr, error } = e;
    handleErrorResponse(error || { message: 'Unknown error occurred.', response: xhr });
  }
});

const exportAgencies = async (apiData) => {
  apiData.forEach((obj) => {
    deleteKey(obj, 'buyingAgencyId');
    deleteKey(obj, 'buyingAgencyNetworkId');
  });

  const headers = [
    { header: 'Agency', key: 'name', autoFit: true },
    { header: 'Agency Network', key: 'buyingAgencyNetworkName', autoFit: true },
    { header: 'Country/Region', key: 'country', autoFit: true },
    { header: 'Status', key: 'isEnabled', autoFit: true },
  ];

  await exportToExcel(headers, apiData, 'agencies_extract', 'Agencies Extract');
};

const appName = "";//ArchicubedWeb; //Production
const LoadSubmenu = (section) =>{
  history.push(appName+ '/admin' + (section != '' ? '/'+section : '')) ;
}
class Agencies extends React.Component {
    constructor(props) {
        super(props);
        this.applyFilterTypes = [{
          key: 'auto',
          name: 'Immediately'
        }, {
          key: 'onClick',
          name: 'On Button Click'
        }];
        this.state = {
          showFilterRow: true,
          showHeaderFilter: false,
          currentFilter: this.applyFilterTypes[0].key,
          showColumnLines: false,
          showRowLines: true,
          showBorders: true,
          rowAlternationEnabled: true,
          showModal: false,
          showEditModal: false,
          showConfirmationModal: false,
          fullscreen:false,
          currentBuyingAgencyNetwork: null,
          currentBuyingAgencyCountries: [],
          buyingAgencyNetworkOptions: [],
          showAgencyMenu: true,
          showAgencyNetworkMenu: true,
          oldCheckValue: false,
          validation:true,
          nameVal:true,
          networkVal:true,
          countryVal:true,
          duplicatedValidation:true,
          selectedRowName:''
        };
        this.dataGrid = null;
        this.onShowFilterRowChanged = this.onShowFilterRowChanged.bind(this);
        this.onShowHeaderFilterChanged = this.onShowHeaderFilterChanged.bind(this);
        this.onCurrentFilterChanged = this.onCurrentFilterChanged.bind(this);
        this.buyingAgencyName = React.createRef();
        this.buyingAgencyName_Edit = React.createRef();
        this.buyingAgencyNetwork = React.createRef();
        this.buyingAgencyCountries = React.createRef();
        this.buyingAgencyIsEnabled = React.createRef();
        this.confDiag = React.createRef();
      }

      fullscreenHandler=()=>{
        this.setState(prevState =>({fullscreen: !prevState.fullscreen}));
      }
    

      selectedChanged(e) {
        this.setState({
          selectedRowIndex: e.component.getRowIndexByKey(e.selectedRowKeys[0])
        });
      }
   
      handleClose = () =>{
        this.setState({ showConfirmationModal: true });
      }

      closeConfirmationModal = ()=>{
        this.setState({ showConfirmationModal: false });
      }

      doubleCloseModals=()=>{
        this.setState({showModal: false, showEditModal: false, showConfirmationModal:false, validation: true, nameVal: true, networkVal: true, countryVal:true, duplicatedValidation:true});
      }

      // to refresh our datagrid table and close all modals
      useRefresh = ()=>{
          this.dataGrid.useRefresh();
          this.setState({
          showModal: false,
          showEditModal: false,
          showConfirmationModal: false,
        });
      }

      handleEditClose = () =>{
          this.setState({ showConfirmationModal: true });
        }

      openModal = () => {   
        this.setState({showModal:true ,duplicatedValidation: true ,
          validation:true});
        }

      componentDidMount(){
        
        const decoded = jwt_decode(localStorage.getItem('token'));
        this.setState({
          showAgencyMenu: decoded.can_manage_agency === "true",
          showAgencyNetworkMenu: decoded.can_manage_agency_network === "true",
          can_export_to_excel: decoded.can_export_to_excel === "true"
        });
        apiClient.get(buyingAgencyNetworksUrl)
          .then(response  => {
            this.setState({
              buyingAgencyNetworkOptions: response.data
            })
          });
      }
    compare( a, b ) {
      if ( a.name < b.name ){
        return -1;
      }
      if ( a.name > b.name ){
        return 1;
      }
      return 0;
    }
  
  openEditModal = (e) => {    
    let buyingAgencyId = e.row.key;
    let buyingAgency = e.row.data;

    this.setState({
      selectedRowName: e.row.data.name.trim(), 
      duplicatedValidation: true,
      validation:true
    })
    
    const enabledAgencyNetworks = this.state.buyingAgencyNetworkOptions.filter(obj => {
      return obj.isEnabled === true;
    });
    this.setState({buyingAgencyNetworkOptions:enabledAgencyNetworks });
    if(enabledAgencyNetworks.find(x=>x.buyingAgencyNetworkId == buyingAgency.buyingAgencyNetworkId) == undefined){
        var agencyNetworkOptions = enabledAgencyNetworks;
        agencyNetworkOptions.push( {
          buyingAgencyNetworkId:buyingAgency.buyingAgencyNetworkId,
          name :buyingAgency.buyingAgencyNetworkName,
          isEnabled:false
        })
        agencyNetworkOptions.sort( this.compare );
        this.setState({buyingAgencyNetworkOptions:agencyNetworkOptions })
      }

      apiClient.get(countriesFromBuyingAgencyUrl.concat(buyingAgencyId))
      .then(response => {
        const countries = response.data;
        this.setState({
          selectedRowIndex: buyingAgencyId,
          currentBuyingAgencyNetwork: buyingAgency.buyingAgencyNetworkId,
          currentBuyingAgencyCountries: countries,
          showEditModal: true
        });
    
        this.buyingAgencyName_Edit.current.value = buyingAgency.name;
        this.buyingAgencyIsEnabled.current.checked = buyingAgency.isEnabled;
        this.buyingAgencyNetwork.current.value = buyingAgency.buyingAgencyNetworkId;
      });
    
    this.setState({ oldCheckValue: e.row.data.isEnabled });
    
   }
   
  onExportToExcel = () => {
    apiClient.get(`${url}/BuyingAgencyMicroservice/Export`)
    .then(response => {
        const data = response.data;
        if (data) {
          exportAgencies(data);
          toast.success('Agencies Excel export file has been generated');
        }
      });
  }

  insertBuyingAgency = (buyingAgency, successMessage) => {
    apiClient.post(buyingAgencyUrl, buyingAgency)
      .then(response => {
        const data = response.data;
        if (data) {
          toast.success('Agency has been created');
          this.doubleCloseModals();
          this.useRefresh();
        }
      });
  }
  

  onCreateBuyingAgency = () => {
    let name = this.buyingAgencyName.current.value.trim();
    let networkId = this.buyingAgencyNetwork.current.value;
    let countriesIds = this.buyingAgencyCountries.current.state.optionsSelected;
    let isEnabled = true;
    let countryValidation;
    this.setState({ duplicatedValidation: true })

    this.buyingAgencyCountries.current.getValidation();

    if (name == "") {
      this.setState({ nameVal: false })
    } else {
      this.setState({ nameVal: true })
    }
    if (networkId == "") {
      this.setState({ networkVal: false })
    } else {
      this.setState({ networkVal: true })
    }
    if (countriesIds == null || !countriesIds.length) {
      this.setState({ countryVal: false })
      countryValidation = true;
    } else {
      this.setState({ countryVal: true })
      countryValidation = false;
    }


    if (name != "" && networkId != "" && !countryValidation) {
      this.setState({ validation: true })

      let buyingAgency = {
        Name: name,
        BuyingAgencyNetworkId: networkId,
        GeoElementsIds: countriesIds.map(country => country.value),
        IsEnabled: isEnabled
      }
      apiClient.post(buyingAgencyUrl, buyingAgency)
        .then(response => {
          const data = response.data;
          if (data) {
            if (data.statusCode == 400 || data.status == 400) {
              this.setState({ duplicatedValidation: false })
              return;
            } else {
              toast.success('Agency has been created');
              this.doubleCloseModals();
              this.useRefresh();
            }
          }
        });
    }
    else {
      this.setState({ validation: false })
      return;
    }
  }


  onEditBuyingAgency = () => {
    let buyingAgencyId = this.state.selectedRowIndex;
    let name = this.buyingAgencyName_Edit.current.value.trim();
    let networkId = this.buyingAgencyNetwork.current.value;
    let countriesIds = this.buyingAgencyCountries.current.state.optionsSelected;
    let countryValidation;

    this.setState({duplicatedValidation: true})

    this.buyingAgencyCountries.current.getValidation();

    if (name == ""){
      this.setState({nameVal: false})
    }else{
      this.setState({nameVal: true})
    }
    if (networkId == ""){
      this.setState({networkVal: false})
    }else{
      this.setState({networkVal: true})
    }
    if (countriesIds == null || !countriesIds.length){
      this.setState({countryVal: false})
      countryValidation=true;
    }else{
      this.setState({countryVal: true})
      countryValidation=false;
    }

  
    if(name != "" && networkId != "" && !countryValidation){   
      this.setState({validation: true})

    let buyingAgency = {
      BuyingAgencyId: buyingAgencyId,
      Name: name,
      BuyingAgencyNetworkId: networkId,
      GeoElementsIds: countriesIds.map(country => country.value),
    }

      apiClient.put(buyingAgencyUrl, buyingAgency)
        .then(response => {
          const data = response.data;
          if (data) {
            if (data.statusCode == 400 || data.status == 400) {
              this.setState({ duplicatedValidation: false })
              return;
            } else {
              if (this.state.oldCheckValue != this.buyingAgencyIsEnabled.current.checked) {
                this.confDiag.current.state.status = this.buyingAgencyIsEnabled.current.checked
                this.confDiag.current.state.inEditMode = true;
                this.confDiag.current.state.key = this.state.selectedRowIndex;
                this.confDiag.current.handleOpenConfirmDialog();
              } else {
                toast.success('Agency has been updated');
                this.useRefresh();
              }
            }
          }
        });

  }else{
    this.setState({validation: false})
    return;
  }
  }

  showDisabledEnabledToast = (value) => {
    if(!this.confDiag.current.state.inEditMode) {
      if(!value) {
        toast.success('Agency has been enabled');
      }
      else {
        toast.success('Agency has been disabled');
      }
    }
    else {
      if(value) {
        toast.success('Agency has been enabled');
      }
      else {
        toast.success('Agency has been disabled');
      }
    }
  }

   Checkisenabled = (e) =>{
    return e.row.data.isEnabled ;
    }

   Checkisdisabled = (e) =>{
      return !e.row.data.isEnabled ;
    }

    onDelete = (e) => {
      this.confDiag.current.state.key = e.row.data.buyingAgencyId;
      this.confDiag.current.state.status = e.row.data.isEnabled;
      this.confDiag.current.state.inEditMode = false;
      this.confDiag.current.handleOpenConfirmDialog();
    }


  render() {
    let networksOptions = this.state.buyingAgencyNetworkOptions.map(network => {
      return <option value={network.buyingAgencyNetworkId}>{network.name}</option>
    })

    const columns = [
      { dataField: "isEnabled", caption: "Status", width: "110" },
      { dataField: "name", caption: "Agency Name", width: "33%" },
      { dataField: "buyingAgencyNetworkName", caption: "Agency Network", width: "33%" },
      // Add other columns specific to Profiles component
    ];

    const buttonColumn = [
      {text: "Edit", icon: editimg, className: "img-grid", name: "edit", onClick: this.openEditModal},
      {text: "btn_enabled", icon: onimg, hint: "Disable", visible: this.Checkisenabled, name: "delete", onClick: this.onDelete},
      {text: "btn_disabled", icon: offimg, hint: "Enable", visible: this.Checkisdisabled, name: "delete", onClick: this.onDelete},
      // Additional buttons for Profiles component
    ];
     
    return (
      <div className="div-body-section-details">
        <div className="div-body-section-details-header">
        <div className="div-section-title">
          <span>          
          {'Agencies >  Agencies Management'}
          </span>
        </div>
        <div className="div-section-actions push">
          <button className={this.state.can_export_to_excel ? "btn-section-header" : "btn-section-header hidden" } onClick={this.onExportToExcel}>
              <img className="img-section-header" src={exportimg} />
              <label>Export To Excel</label></button>
          <button  className="btn-section-header"   onClick={this.openModal}>
              <img className="img-section-header" src={plusimg} />
              <label>New Agency</label>
          </button>
        </div>
        </div>
        <div className="div-body-section-details-body">
          <div className="div-body-submenu">
          <div className={this.state.showAgencyMenu ? "div-submenu-link active" : "div-submenu-link hidden"} onClick={() => LoadSubmenu('agencies')} >              
             <div class="div-submenu-label">
                    <label>Agencies</label>
                </div> 
                            
            </div>
            <div className={this.state.showAgencyNetworkMenu ? "div-submenu-link" : "div-submenu-link hidden"}  onClick={() => LoadSubmenu('agencynetworks')} >              
             <div class="div-submenu-label">
                    <label>Agency Networks</label>
                </div> 
                            
            </div>        
          </div>
        <div  className="div-padding-20 div-grid-result">
            <CustomDataGrid
              dataSource={dataSource}
              keyExpr="buyingAgencyId"
              ref={(ref) => (this.dataGrid = ref)}
              rowAlternationEnabled={this.state.rowAlternationEnabled}
              onSelectionChanged={this.selectionChanged}
              showFilterRow={this.state.showFilterRow}
              currentFilter={this.state.currentFilter}
              showHeaderFilter={this.state.showHeaderFilter}
              columns={columns}
              buttonColumn={buttonColumn}
            />
      </div>
      </div>
  <Modal show={this.state.showModal} onHide={this.handleClose} size="md" centered fullscreen={this.state.fullscreen}>
      <Modal.Header closeButton>
        <Modal.Title size="h6" >New Agency</Modal.Title>
        <button
            type="button"
            class="btn btn-primary admin-btn"
            onClick={this.fullscreenHandler}
          >
            {this.state.fullscreen ? <Maximize /> : <Minimize />}
          </button>
      </Modal.Header>
      <Modal.Body>  
      {!this.state.duplicatedValidation && <Row className="mb-3 col-md-12"><p className='mandatory-validation'>This Agency already exists, your updates cannot be saved. Please go back to Agencies Management list to edit the corresponding form.</p></Row>  } 
      {!this.state.validation && this.state.duplicatedValidation && <Row className="mb-3 col-md-12"><p className='mandatory-validation'>Mandatory fields are missing. Saving of the Agency form is not allowed</p></Row>  }
        <Row>
          <Form.Group className="mb-3 col-md-12" controlId="Name">
            <Form.Label className={`${this.state.nameVal ? "normal-title" : "validation-title"}`}>Name <CircleSign/></Form.Label>
            <Form.Control 
              className={`${!this.state.nameVal && "validation-control"} margin-bot-1`} 
              type="text" 
              ref={this.buyingAgencyName} 
              placeholder="Name"/>
            {!this.state.nameVal && <p className="p-required">Required</p>}

            <Form.Label className={`${this.state.networkVal ? "normal-title" : "validation-title"}`}>Agency Network <CircleSign/></Form.Label>
            <Form.Control 
              className={`select-placeholder ${!this.state.networkVal && "validation-control"} margin-bot-1`} 
              ref={this.buyingAgencyNetwork}  
              placeholder="Agency Network" 
              as="select" 
              type="select"
              required
              defaultValue="">
            <option value="" hidden>Agency Network</option>
              {networksOptions}                                
            </Form.Control>
            {!this.state.networkVal && <p className="p-required">Required</p>}

            <Form.Label className={`${this.state.countryVal ? "normal-title" : "validation-title"}`}>Country/Region <CircleSign/></Form.Label>
            <CustomReactSelect 
              loadUrl={countriesLoadUrl} 
              isMulti={true}
              idColumnName='geoElementId'
              ref={this.buyingAgencyCountries}
            />
          </Form.Group>
        </Row>     
      </Modal.Body>
      <Modal.Footer>
      <ButtonBootstrap variant="primary" className='btnPrimary' onClick={this.onCreateBuyingAgency}>
          Create Agency
        </ButtonBootstrap>
        <ButtonBootstrap variant="secondary" className='btnSecondary' onClick={this.handleClose}>
          Cancel
        </ButtonBootstrap>
      </Modal.Footer>
    </Modal> 

    <Modal show={this.state.showEditModal} onHide={this.handleEditClose} size="md" centered fullscreen={this.state.fullscreen}>
      <Modal.Header closeButton>
        <Modal.Title size="h6"> Edit Agency</Modal.Title>
        <button
            type="button"
            class="btn btn-primary admin-btn"
            onClick={this.fullscreenHandler}
          >
            {this.state.fullscreen ? <Maximize /> : <Minimize />}
          </button>
      </Modal.Header>
      <Modal.Body>
      {!this.state.duplicatedValidation && <Row className="mb-3 col-md-12"><p className='mandatory-validation'>This Agency already exists, your updates cannot be saved. Please go back to Agencies Management list to edit the corresponding form.</p></Row>  } 
      {!this.state.validation && this.state.duplicatedValidation && <Row className="mb-3 col-md-12"><p className='mandatory-validation'>Mandatory fields are missing. Saving of the Agency form is not allowed</p></Row>  }
        <Row>
          <Form.Group className="mb-3 col-md-12" controlId="Name">
          <Form.Label className={`${this.state.nameVal ? "normal-title" : "validation-title"}`}>Name  <CircleSign/></Form.Label>
           <Form.Control className={`${!this.state.nameVal && "validation-control"} margin-bot-1`} type="text" ref={this.buyingAgencyName_Edit} placeholder="Name"/>
           {!this.state.nameVal && <p className="p-required">Required</p>}

            <Form.Label className={`${this.state.networkVal ? "normal-title" : "validation-title"} margin-bot-1`}>Agency Network  <CircleSign/></Form.Label>
            <Form.Control 
              className={`select-placeholder ${!this.state.networkVal && "validation-control"}`} 
              ref={this.buyingAgencyNetwork}  
              placeholder="Agency Network" 
              as="select" 
              required
              defaultValue="">
                <option value="" hidden>Agency Network</option>
                {networksOptions}                                
            </Form.Control>
             {!this.state.networkVal && <p className="p-required">Required</p>}

            <Form.Label className={`${this.state.countryVal ? "normal-title" : "validation-title"}`}>Country/Region  <CircleSign/></Form.Label>
            <CustomReactSelect 
              loadUrl={countriesLoadUrl} 
              isMulti={true}
              itemsSelected={this.state.currentBuyingAgencyCountries}
              idColumnName='geoElementId'
              ref={this.buyingAgencyCountries}
            />
            <br/>
            <Form.Check type="checkbox" label="Is Enabled" ref={this.buyingAgencyIsEnabled}/>
          </Form.Group>
        </Row>
      </Modal.Body>
      <Modal.Footer>
      <ButtonBootstrap variant="primary" className='btnPrimary' onClick={this.onEditBuyingAgency}>
          Update Agency
        </ButtonBootstrap>
        <ButtonBootstrap variant="secondary" className='btnSecondary' onClick={this.handleEditClose}>
          Cancel
        </ButtonBootstrap>
      </Modal.Footer>
    </Modal>

    <ConfirmationModal show={this.state.showConfirmationModal} hide={this.closeConfirmationModal} doubleCloseModals={this.doubleCloseModals} msg="Your updates won't be saved. Are you sure you want to leave this page
          ?"/>


    <ConfirmDialog ref={this.confDiag} microserviceName="BuyingAgencyMicroservice" editfunction={this.showDisabledEnabledToast} refreshfunction={this.useRefresh} title="Can't enable Agency" msg="You can't enable this Agency because it is linked to a disabled Agency Network. Please modify the Agency Network selected or go to Agency Networks administration to enable the current one."></ConfirmDialog>

      <ToastContainer position="bottom-right"/>  
      </div>
    );
  }
      onShowFilterRowChanged(e) {
        this.setState({
          showFilterRow: e.value
        });
        this.clearFilter();
      }
      onShowHeaderFilterChanged(e) {
        this.setState({
          showHeaderFilter: e.value
        });
        this.clearFilter();
      }
      onCurrentFilterChanged(e) {
        this.setState({
          currentFilter: e.value
        });
      }
      clearFilter() {
        this.dataGrid.clearFilter();
      }
}

export default Agencies;
